// src/admin/pages/Auth/ProtectedRoute.js
import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { Navigate } from "react-router-dom";
import { authFetch } from "./authFetch";   // wrapper fetch

/* util redirect unico */
function redirectToLogin() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  window.location.replace("/");  // tua AuthPage vive su "/"
}

function ProtectedRoute({ children, requiredRole }) {
  const [authState, setAuthState] = useState("loading"); // loading | allowed | redirect
  const [blocked, setBlocked]     = useState(false);
  const [blockedMsg, setBlockedMsg] = useState("");

  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* Timer che scatta pochi secondi prima di exp */
  const scheduleExpiryRedirect = (decoded) => {
    if (!decoded.exp) return;
    const now      = Date.now();
    const expMs    = decoded.exp * 1000;
    const deltaMs  = expMs - now - 5000;    // 5 s di margine
    if (deltaMs <= 0) {
      redirectToLogin();
    } else {
      setTimeout(() => redirectToLogin(), deltaMs);
    }
  };

  const checkAccess = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      setAuthState("redirect");
      return;
    }

    try {
      const decoded = jwtDecode(token);
      scheduleExpiryRedirect(decoded);          // <‑‑ nuovo

      const now = Math.floor(Date.now() / 1000);
      if (decoded.exp && decoded.exp < now) {
        setAuthState("redirect");
        return;
      }

      if (requiredRole &&
          decoded.role !== requiredRole &&
          decoded.role !== "super_admin") {
        setAuthState("redirect");
        return;
      }

      const res = await authFetch(`${process.env.REACT_APP_API_URL}/users/me`);
      if (res.status === 403) {
        const data = await res.json();
        if (data.detail?.includes("disattivata")) {
          setBlocked(true);
          setBlockedMsg(data.detail);
          setAuthState("allowed");
          return;
        }
        setAuthState("redirect");
        return;
      }
      if (!res.ok) {
        setAuthState("redirect");
        return;
      }

      setAuthState("allowed");
    } catch (err) {
      console.error("Errore ProtectedRoute:", err);
      setAuthState("redirect");
    }
  };

  if (authState === "loading") return <div>Verifica in corso…</div>;
  if (authState === "redirect") return <Navigate to="/" replace />;

  if (blocked) {
    return (
      <div style={styles.overlay}>
        <div style={styles.modal}>
          <h2>Account Disattivato</h2>
          <p>{blockedMsg || "La tua compagnia è disattivata"}</p>
          <p>Contatta il supporto per ulteriori informazioni.</p>
        </div>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;

const styles = {
  overlay: {
    position: "fixed", top: 0, left: 0,
    width: "100%", height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex", justifyContent: "center", alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#fff", padding: 20, borderRadius: 8, maxWidth: 400, textAlign: "center",
  },
};
